import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

/**
 * PageContainer
 *
 * This component is in charge of displaying
 * the Page Container
 *
 * @return {jsx}
 */

const PageContainer = ({ className, children }) => <div className={className}>{children}</div>;

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
PageContainer.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
PageContainer.defaultProps = {
  className: '',
  children: null,
};

export default styled(PageContainer)`
  width: 62rem;
  height: auto;
  min-height: 230px;
  margin: 0 auto;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme: { palette } }) => palette.lightGrey};

  background: ${({ theme: { palette } }) => palette.white};

  /* For small devices */
  ${breakpoint('xs', 'md')`
    width: 100%;
    height: 100%;

    border-radius: 0;
    border: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/PageContainer/index.js